module.exports = __webpack_public_path__ + "static/media/test-banner.5b7cc5c0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/test-banner.jpeg
// module id = 1134
// module chunks = 1